import React, { useState } from "react";
import { TextField, Chip, Box, IconButton } from "@mui/material";
import { Add as AddIcon, Close as CloseIcon } from "@mui/icons-material";

const CustomChipField = ({ errors, setErrors, data, setData, name, validators, label, ...rest }) => {
    const [inputValue, setInputValue] = useState("");

    const handleInputChange = (event) => {
        setInputValue(event.target.value);
    };

    const validate = (value) => {
        if (!validators || !validators[name]) return { valid: true };
        for (let validator of validators[name]) {
            const { valid, error } = validator(value);
            if (!valid) return { valid, error };
        }
        return { valid: true };
    };

    const handleAddChip = () => {
        const trimmedValue = inputValue.trim();
        if (!trimmedValue) return;
        const { valid, error } = validate(trimmedValue);
        if (!valid) {
            setErrors({ ...errors, [name]: error });
            return;
        }
        if (data[name]?.includes(trimmedValue)) {
            setErrors({ ...errors, [name]: "Already added" });
            return;
        }
        setData({ ...data, [name]: [...(data[name] || []), trimmedValue] });
        setErrors({ ...errors, [name]: false });
        setInputValue("");
    };

    const handleDeleteChip = (chipToDelete) => {
        setData({ ...data, [name]: data[name].filter((chip) => chip !== chipToDelete) });
    };

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            handleAddChip();
        }
    };

    return (
        <Box>
            <TextField
                label={label}
                name={name}
                value={inputValue}
                onChange={handleInputChange}
                onKeyDown={handleKeyDown}
                error={Boolean(errors[name])}
                helperText={errors[name] && errors[name]}
                {...rest}
                InputProps={{
                    endAdornment: (
                        <IconButton onClick={handleAddChip} edge="end" size="small">
                            <AddIcon />
                        </IconButton>
                    ),
                }}
            />
            <Box sx={{ mt: 1, display: "flex", flexWrap: "wrap", gap: 1 }}>
                {(data[name] || []).map((chip, idx) => (
                    <Chip
                        key={chip + idx}
                        label={chip}
                        onDelete={() => handleDeleteChip(chip)}
                        deleteIcon={<CloseIcon />}
                    />
                ))}
            </Box>
        </Box>
    );
};

export default CustomChipField; 